import { render, staticRenderFns } from "./Rutas1.vue?vue&type=template&id=5833d2fb&scoped=true&"
import script from "./Rutas1.vue?vue&type=script&lang=js&"
export * from "./Rutas1.vue?vue&type=script&lang=js&"
import style0 from "./Rutas1.vue?vue&type=style&index=0&id=5833d2fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5833d2fb",
  null
  
)

export default component.exports